"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsUSDateString = void 0;
exports.IsUSDateString = (e) => e;
//# sourceMappingURL=is-us-date-string.js.map